var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFE7BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9812 3.87452C9.07812 3.8839 3.5 9.46827 3.5 16.3714C3.5 20.3714 5.38125 23.9339 8.30625 26.2214L7.13438 27.7214C7.00625 27.887 7.125 28.1276 7.33125 28.1245L12.55 28.0995C12.7125 28.0995 12.8312 27.9464 12.7906 27.7901L11.5562 22.7183C11.5451 22.6726 11.5213 22.6309 11.4875 22.5981C11.4538 22.5653 11.4114 22.5428 11.3654 22.533C11.3194 22.5232 11.2715 22.5266 11.2273 22.5428C11.1831 22.559 11.1444 22.5873 11.1156 22.6245L9.84375 24.2526C9.525 24.0026 9.21875 23.7308 8.92813 23.4401C8.01444 22.5296 7.28636 21.4503 6.78438 20.262C6.2625 19.0308 6 17.7214 6 16.3714C6 15.0214 6.2625 13.712 6.78438 12.4808C7.2875 11.2901 8.00938 10.2214 8.92813 9.30265C9.84688 8.3839 10.9156 7.66202 12.1062 7.1589C13.3406 6.63702 14.65 6.37452 16 6.37452C17.35 6.37452 18.6594 6.63702 19.8906 7.1589C21.0812 7.66202 22.15 8.3839 23.0688 9.30265C23.9875 10.2214 24.7094 11.2901 25.2125 12.4808C25.7344 13.712 25.9969 15.0214 25.9969 16.3714C25.9969 17.7214 25.7344 19.0308 25.2125 20.262C24.7105 21.4503 23.9824 22.5296 23.0688 23.4401C22.8344 23.6745 22.5906 23.8933 22.3375 24.1026C22.2868 24.1438 22.2544 24.2034 22.2474 24.2684C22.2403 24.3333 22.2593 24.3984 22.3 24.4495L23.5312 26.0276C23.6187 26.137 23.7781 26.1558 23.8875 26.0683C26.7031 23.7745 28.5 20.2839 28.5 16.3714C28.5 9.46202 22.8937 3.86515 15.9812 3.87452Z",
    fill: "#AD4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnWarn);
export default __webpack_public_path__ + "static/media/return-warn.54d1b6ce097e40bd41bba98c3a92b104.svg";
export { ForwardRef as ReactComponent };